import { LoadingStates } from '@pb/utils'
import { createReducer } from 'redux-act'

import { RazorpayData } from '../../checkout/types'
import { RazorpayState } from '../types'
import * as actions from './actions'
import { initialState } from './initialState'

const initRazorpayCheckout = (state: RazorpayState, data: RazorpayData): RazorpayState => ({
  ...state,
  data,
  initStatus: LoadingStates.LoadedSuccess,
})

const apiInitRazorpayStart = (state: RazorpayState): RazorpayState => ({
  ...state,
  initStatus: LoadingStates.Loading,
})

const completeRazorpayCheckout = (state): RazorpayState => ({
  ...state,
  data: null,
  status: LoadingStates.NotLoaded,
})

// TODO: check what info we get from Hybris (k.solovei, 15.02.2023)
const apiInitRazorpaySuccess = (state: RazorpayState): RazorpayState => ({
  ...state,
  initStatus: LoadingStates.LoadedSuccess,
})

const apiInitRazorpayFail = (state: RazorpayState): RazorpayState => ({
  ...state,
  initStatus: LoadingStates.LoadedFail,
})

export default createReducer((on) => {
  on(actions.initRazorpayCheckout, initRazorpayCheckout)
  on(actions.apiInitRazorpayStart, apiInitRazorpayStart)
  on(actions.completeRazorpayCheckout, completeRazorpayCheckout)
  on(actions.apiInitRazorpaySuccess, apiInitRazorpaySuccess)
  on(actions.apiInitRazorpayFail, apiInitRazorpayFail)
}, initialState)
